// extracted by mini-css-extract-plugin
export var sliderRange = "_cp-2";
export var sliderRoot = "_cp-0";
export var sliderThumb = "_cp-3";
export var sliderTrack = "_cp-1";